import React, { Activity, useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Avatar from '@mui/material/Avatar';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone';
import useConfig from 'hooks/useConfig';

// types
import { I18n } from 'types/config';
import { defaultSession, useSession } from '../../../../SessionContext';
// ==============================|| LOCALIZATION ||============================== //

export default function LocalizationSection() {
  const {
    state: { borderRadius, i18n },
    setField
  } = useConfig();
  const { session, setSession } = useSession();


  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = useState(false);
  const anchorRef = useRef<any>(null);

  const handleListItemClick = (
    _event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
    lng: I18n
  ) => {
    console.log('Language changed to:', lng);
    setField('i18n', lng);
    const asString: string = lng;
    setSession({ ...(session ?? defaultSession), language: asString });
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Box sx={{ ml: { xs: 0, sm: 2 } }}>        
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            color: theme.vars.palette.primary.dark,
            background: theme.vars.palette.primary.light,
            
            '&:hover, &[aria-controls="menu-list-grow"]': {
              color: theme.vars.palette.primary.light,
              background: theme.vars.palette.primary.main
              //background: theme.vars.palette.primary.dark
            },

            ...theme.applyStyles('dark', {
              color: theme.vars.palette.primary.dark,
              background: theme.vars.palette.dark.main,
              '&:hover, &[aria-controls="menu-list-grow"]': {
                color: theme.vars.palette.primary.light,
                background: theme.vars.palette.primary.main
              }
            })
          }}
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          alt="language"
          onClick={handleToggle}
        >
          <Activity mode={i18n !== 'en' ? 'visible' : 'hidden'}>
            <Typography variant="h5" sx={{ textTransform: 'uppercase', color: 'inherit' }}>
              {i18n}
            </Typography>
          </Activity>

          <Activity mode={i18n === 'en' ? 'visible' : 'hidden'}>
            <Typography variant="h5" sx={{ textTransform: 'uppercase', color: 'inherit' }}>
            {i18n}
            </Typography>
            {/* <TranslateTwoToneIcon sx={{ fontSize: '1.3rem' }} /> */}
          </Activity>
           {/* <Activity mode={i18n !== 'fr' ? 'visible' : 'hidden'}>
            <Typography variant="h5" sx={{ textTransform: 'uppercase', color: 'inherit' }}>
              {i18n}
            </Typography>
          </Activity> */}
        </Avatar>
      </Box>

      <Popper
        placement={downMD ? 'bottom-start' : 'bottom'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [downMD ? 0 : 0, 20]
            }
          }
        ]}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions position={downMD ? 'top-left' : 'top'} in={open} {...TransitionProps}>
              <Paper elevation={16}>
                <Activity mode={open ? 'visible' : 'hidden'}>
                  <List
                    sx={{
                      width: '100%',
                      minWidth: 200,
                      maxWidth: { xs: 250, sm: 280 },
                      borderRadius: `${borderRadius}px`
                    }}
                  >
                    <ListItemButton selected={i18n === 'en'} onClick={(event) => handleListItemClick(event, 'en')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Typography>English</Typography>
                            <Typography variant="caption" sx={{ ml: '8px' }}>
                              (UK)
                            </Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton>
                    <ListItemButton selected={i18n === 'de'} onClick={(event) => handleListItemClick(event, 'de')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Typography>Deutsch</Typography>
                            <Typography variant="caption" sx={{ ml: '8px' }}>
                              (Germany)
                            </Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton>
                    {/* <ListItemButton selected={i18n === 'fr'} onClick={(event) => handleListItemClick(event, 'fr')}>
                      <ListItemText
                        primary={
                          <Grid container>
                            <Typography>Francais</Typography>
                            <Typography variant="caption" sx={{ ml: '8px' }}>
                              (French)
                            </Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton> */}
                  </List>
                </Activity>
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
}
